// Les primitives communes. Styles en ligne : c'est la décision de stack du projet —
// un style conditionnel se lit comme une phrase là où des classes concaténées se
// déchiffrent. Les couleurs passent toutes par les variables CSS du thème.

export const MONO = 'var(--chiffres)';

// 44 px est le plancher absolu d'iOS ; 56 est le plancher de CE projet pour tout ce
// qu'on touche pendant un match, debout, d'une main, dans le bruit.
export const CIBLE = 56;

export function Bouton({ ton = 'neutre', large = false, taille = 46, style, children, ...reste }) {
  const fonds = {
    principal: { background: 'var(--acc)', color: 'var(--tokink)', border: '1px solid transparent' },
    valide: { background: 'var(--acc2)', color: 'var(--tokink)', border: '1px solid transparent' },
    neutre: { background: 'var(--surf2)', color: 'var(--ink)', border: '1px solid var(--line)' },
    fantome: { background: 'transparent', color: 'var(--ink2)', border: '1px solid var(--line)' },
    danger: { background: 'var(--surf2)', color: 'var(--bad)', border: '1px solid var(--line)' },
  };
  return (
    <button
      style={{
        height: taille, minHeight: taille, padding: large ? '0 20px' : '0 14px',
        borderRadius: 14, fontWeight: 700, fontSize: 14,
        display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 7,
        flex: large ? 1 : 'none', whiteSpace: 'nowrap',
        ...fonds[ton], ...style,
      }}
      {...reste}
    >
      {children}
    </button>
  );
}

export function Chip({ actif, style, children, ...reste }) {
  return (
    <button
      style={{
        flex: 'none', height: 40, padding: '0 15px', borderRadius: 12,
        fontSize: 13, fontWeight: 700, fontFamily: MONO, letterSpacing: '.2px',
        background: actif ? 'var(--acc)' : 'var(--surf2)',
        color: actif ? 'var(--tokink)' : 'var(--ink)',
        border: `1px solid ${actif ? 'transparent' : 'var(--line)'}`,
        ...style,
      }}
      {...reste}
    >
      {children}
    </button>
  );
}

export function Etiquette({ ton = 'var(--ink2)', fond, children, style }) {
  return (
    <span style={{
      padding: '3px 8px', borderRadius: 7, fontSize: 10.5, fontWeight: 700,
      color: ton, border: fond ? 'none' : `1px solid ${ton}`, background: fond ?? 'transparent',
      whiteSpace: 'nowrap', ...style,
    }}>{children}</span>
  );
}

export const Titre = ({ children, style }) => (
  <div style={{ fontSize: 10, fontWeight: 700, letterSpacing: '.9px', color: 'var(--ink2)', ...style }}>{children}</div>
);

export const Carte = ({ children, style, ...reste }) => (
  <div style={{ background: 'var(--surf)', border: '1px solid var(--line)', borderRadius: 18, ...style }} {...reste}>{children}</div>
);

/**
 * Le retour haptique d'iOS n'est pas accessible au web. `navigator.vibrate` n'existe
 * pas non plus sur Safari : l'appel est donc silencieux là où ça compte, et présent
 * pour les autres. On ne construit rien dessus — c'est une garniture, pas un signal.
 */
export const toucher = (ms = 8) => { try { navigator.vibrate?.(ms); } catch { /* sans effet */ } };
